import Link from 'next/link'
import Image from 'next/image'
import { FC, ReactNode } from 'react'
import { typography } from '@lifedot/styles/typography'
import { css } from '@emotion/react'
import { mq } from '@lifedot/styles/mediaQuery'
import { palette } from '@lifedot/styles/palette'
import { getDirector } from '@lifedot/utils'

const styles = {
  commentWrap: css({
    display: 'flex',
    [mq('sp')]: {
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  }),
  director: css({
    marginRight: 12,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flexShrink: 0,
    [mq('sp')]: {
      flexDirection: 'row',
      margin: '0 0 8px'
    }
  }),
  directorImg: css({
    width: 72,
    borderRadius: '50%',
    [mq('sp')]: {
      width: 64,
      marginRight: 8
    }
  }),
  name: css({
    fontWeight: 'bold',
    textAlign: 'center',
    [mq('sp')]: {
      textAlign: 'left'
    }
  }),
  comment: css({
    border: `2px solid ${palette.gray2}`,
    borderRadius: 4,
    padding: 12,
    backgroundColor: palette.white,
    position: 'relative',
    ':before': {
      content: '""',
      position: 'absolute',
      top: 28,
      left: -20,
      border: '8px solid transparent',
      borderRight: `12px solid ${palette.gray2}`
    },
    ':after': {
      content: '""',
      position: 'absolute',
      top: 28,
      left: -16,
      border: '8px solid transparent',
      borderRight: `12px solid ${palette.white}`
    },
    [mq('sp')]: {
      ':before': {
        top: -18,
        left: 20,
        transform: 'rotate(90deg)'
      },
      ':after': {
        top: -14,
        left: 20,
        transform: 'rotate(90deg)'
      }
    }
  })
}

export interface DirectorCommentProps {
  cemeteryId: number
  children: ReactNode
}

export const DirectorComment: FC<DirectorCommentProps> = (props) => {
  const { cemeteryId, children } = props

  const { iconImagePath, name, textLinkPath } = getDirector(cemeteryId)

  return (
    <div css={styles.commentWrap}>
      <div css={styles.director}>
        <figure css={styles.directorImg}>
          <Image
            src={iconImagePath}
            width={120}
            height={120}
            alt={`お墓ディレクター${name}の写真`}
          />
        </figure>
        <Link href={textLinkPath} passHref prefetch={false}>
          <a css={[typography.textM, styles.name]}>
            <small>お墓ディレクター</small>
            <br />
            {name}
          </a>
        </Link>
      </div>
      <div css={[typography.textM, styles.comment]}>{children}</div>
    </div>
  )
}
